// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
const {
  ARTICLE_IS_MIXED_CHANGE_PENDING
} = require('client-v2/common/models/article/actions')
// Sibling imports
const {
  SHOW,
  HIDE,
  ARTICLE_FAILED,
  ARTICLE_LOADED,
  ARTICLE_LOADING,
  SUBMIT_INVALID_URL,
  SUBMIT_LOADED,
  SUBMIT_FAILED,
  SET_URL_TEXT
} = require('./actions')
const ContentAddModalRecord = require('./record')

// eslint-disable-next-line complexity
function contentAddModalReducer(
  state = new ContentAddModalRecord(),
  { type, payload }
) {
  if (type === SHOW) {
    return new ContentAddModalRecord()
    .merge({
      isSubmitPending: false,
      isVisible: true,
      url: payload.url
    })
  }
  // All other actions should only matter after SHOW
  if (!state) {
    return state
  }
  switch (type) {
    // Visibility
    case HIDE:
    case SUBMIT_LOADED:
      return new ContentAddModalRecord()
    // Controlled inputs
    case SET_URL_TEXT:
      return state
      .setArticle(null)
      .merge({
        articleState: FetchStateEnum.EMPTY,
        url: payload,
        isUrlInvalid: false
      })
    // Article
    case ARTICLE_IS_MIXED_CHANGE_PENDING:
      return state.merge({
        isSubmitPending: ARTICLE_IS_MIXED_CHANGE_PENDING
      })
    case ARTICLE_FAILED:
      return state
      .setArticle(null)
      .merge({
        articleState: FetchStateEnum.FAILED
      })
    case ARTICLE_LOADED:
      return state
      .setArticle(payload)
      .merge({
        articleState: FetchStateEnum.LOADED
      })
    case ARTICLE_LOADING:
      return state.merge({
        articleState: FetchStateEnum.LOADING
      })
    // Submit
    case SUBMIT_FAILED:
      return state.merge({
        isSubmitPending: false
      })
    case SUBMIT_INVALID_URL:
      return state.merge({
        isUrlInvalid: true
      })
    default:
      return state
  }
}

module.exports = contentAddModalReducer
